import {
    LIST_ALL_USER_TXNS,
    RESET_ALL_USER_TXNS,
    LIST_USER_PROFILE,
    RESET_USER_PROFILE,
    UPDATE_WALLET_BALANCE,
    LIST_BLOCKCHAIN_TXN_HISTORY,
    RESET_BLOCKCHAIN_TXN_HISTORY,
    LIST_RAMPAY_USER_ID,
    RESET_RAMPAY_USER_ID,
    RAMPAY_ORDER_ID,
    RESET_RAMPAY_ORDER_ID,
} from "../types";

const INITIAL_STATE = {
    profile: {},
    blockchainTxns: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 10,
    },
    txns: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 10,
    },
    rampayUid: {},
    rampayOrderId: {},
};

const userReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case LIST_USER_PROFILE:
            return {
                ...state,
                profile: payload,
            };

        case LIST_ALL_USER_TXNS:
            return {
                ...state,
                txns: payload,
            };

        case LIST_RAMPAY_USER_ID:
            return {
                ...state,
                rampayUid: payload,
            };

        case RESET_RAMPAY_USER_ID:
            return {
                ...state,
                rampayUid: INITIAL_STATE.rampayUid,
            };

        case RAMPAY_ORDER_ID:
            return {
                ...state,
                rampayOrderId: payload,
            };

        case RESET_RAMPAY_ORDER_ID:
            return {
                ...state,
                rampayOrderId: INITIAL_STATE.rampayOrderId,
            };

        case RESET_ALL_USER_TXNS:
            return {
                ...state,
                txns: INITIAL_STATE.txns,
            };

        case RESET_USER_PROFILE:
            return {
                ...state,
                profile: INITIAL_STATE.profile,
            };

        case LIST_BLOCKCHAIN_TXN_HISTORY:
            return {
                ...state,
                blockchainTxns: payload,
            };

        case RESET_BLOCKCHAIN_TXN_HISTORY:
            return {
                ...state,
                blockchainTxns: INITIAL_STATE.blockchainTxns,
            };

        case UPDATE_WALLET_BALANCE:
            const wallets = state.profile?.wallets ?? [];
            wallets.map((e) => {
                if (e.network === payload.network) {
                    e.balance = payload.balance;
                }
                return e;
            });
            state.profile.wallets = wallets;
            return {
                ...state,
                profile: state.profile,
            };

        default:
            return state;
    }
};

export default userReducer;
